import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Typography,
  Row,
  Col,
  Button,
  Form,
  Input,
  Spin,
} from 'antd';
import {
  ArrowLeftOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import { onError } from 'utils/handlers';
import { postCancelarRecibo } from 'api/recaudacion/recibos';

const { Text } = Typography;

const ModalCancel = ({
  visible,
  setVisible,
  reciboId,
  callback,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const canceled = await postCancelarRecibo(reciboId, values);
      if (canceled) {
        await callback(5, canceled);
        setVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const ModalControls = () => (
    <Row className="form-submit-controls">
      <Col xs={24} sm={24} md={0}>
        <Row>
          <Button
            type="link"
            onClick={() => setVisible(false)}
          >
            <ArrowLeftOutlined />
          </Button>
          <Button
            type="link"
            onClick={() => onFinish()}
            className="no-color danger"
            icon={<CloseCircleOutlined />}
          />
        </Row>
      </Col>
      <Col xs={0} sm={0} md={24}>
        <Row>
          <Button
            type="link"
            onClick={() => setVisible(false)}
            icon={<ArrowLeftOutlined />}
          >
            Regresar
          </Button>
          <Button
            type="link"
            onClick={() => onFinish()}
            style={{ marginLeft: 10 }}
            className="no-color danger"
            icon={<CloseCircleOutlined />}
          >
            Cancelar
          </Button>
        </Row>
      </Col>
    </Row>
  );

  const rules = {
    observacion_de_la_cancelacion: [{ required: true }],
  };

  return (
    <Modal
      title={(
        <Row justify="space-between">
          <Text>
            Cancelación
          </Text>
          <ModalControls />
        </Row>
        )}
      className="modal-delete"
      visible={visible}
      footer={null}
      closable={false}
    >
      <Spin
        tip="Cargando..."
        spinning={loading}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={() => onFinish()}
        >
          <Row gutter={10}>
            <Col span={24}>
              <Form.Item
                name="observacion_de_la_cancelacion"
                rules={rules.observacion_de_la_cancelacion}
                hasFeedback
                label="Observaciones"
              >
                <Input />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};

ModalCancel.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  reciboId: PropTypes.number.isRequired,
  callback: PropTypes.func.isRequired,
};

export default ModalCancel;
